<div class="insights-container">
  <nz-spin [nzSpinning]="loadingContext">
    <div class="page-header">
      <div class="page-header__titles">
        <h1>{{ 'HOSPITALITY_AI.TITLE' | translate }}</h1>
        <p>{{ 'HOSPITALITY_AI.DESCRIPTION' | translate }}</p>
      </div>
      <button nz-button nzType="default" nzSize="small" (click)="loadMetrics()" [disabled]="loadingMetrics || loadingContext">
        <span nz-icon nzType="reload"></span>
        {{ 'HOSPITALITY_AI.METRICS.REFRESH' | translate }}
      </button>
    </div>

    <form nz-form class="filters-form" [formGroup]="filtersForm" (ngSubmit)="applyFilters()">
      <div class="filters-form__row">
        <nz-form-item>
          <nz-form-label>{{ 'HOSPITALITY_AI.FILTERS.COMPANY' | translate }}</nz-form-label>
          <nz-form-control>
            <nz-select
              formControlName="companyId"
              [nzAllowClear]="canFilterCompanies"
              [nzDisabled]="!canFilterCompanies"
              nzShowSearch
              nzPlaceHolder="{{ 'HOSPITALITY_AI.FILTERS.COMPANY_PLACEHOLDER' | translate }}"
            >
              <nz-option *ngFor="let company of companyOptions" [nzValue]="company.id" [nzLabel]="company.name"></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label>{{ 'HOSPITALITY_AI.FILTERS.PROPERTY' | translate }}</nz-form-label>
          <nz-form-control>
            <nz-select formControlName="propertyId" nzAllowClear nzShowSearch nzPlaceHolder="{{ 'HOSPITALITY_AI.FILTERS.PROPERTY_PLACEHOLDER' | translate }}">
              <nz-option *ngFor="let property of propertyOptionsForFilters" [nzValue]="property.id" [nzLabel]="property.address"></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label>{{ 'HOSPITALITY_AI.FILTERS.LANGUAGE' | translate }}</nz-form-label>
          <nz-form-control>
            <nz-select formControlName="language" nzAllowClear nzPlaceHolder="{{ 'HOSPITALITY_AI.FILTERS.LANGUAGE_PLACEHOLDER' | translate }}">
              <nz-option *ngFor="let language of languageOptions" [nzValue]="language.code" [nzLabel]="('LANGUAGE_NAMES.' + (language.code | uppercase)) | translate"></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>

        <nz-form-item class="filters-form__switch">
          <nz-form-label>{{ 'HOSPITALITY_AI.FILTERS.INCLUDE_INACTIVE' | translate }}</nz-form-label>
          <nz-form-control>
            <nz-switch formControlName="includeInactive"></nz-switch>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div class="filters-form__actions">
        <button nz-button nzType="primary" [disabled]="loadingMetrics || loadingEntries">
          {{ 'HOSPITALITY_AI.FILTERS.APPLY' | translate }}
        </button>
        <button nz-button type="button" nzType="default" (click)="resetFilters()">
          {{ 'HOSPITALITY_AI.FILTERS.RESET' | translate }}
        </button>
      </div>
    </form>

    <nz-card class="metrics-card" [nzLoading]="loadingMetrics">
      <ng-container *ngIf="metrics as metricsData; else noMetrics">
        <div class="metrics-grid">
          <div class="metric-item">
            <span class="metric-item__label">{{ 'HOSPITALITY_AI.METRICS.HELPFUL_RATE' | translate }}</span>
            <span class="metric-item__value">{{ formatHelpfulRate(metricsData.totals.helpfulRate) }}</span>
          </div>
          <div class="metric-item">
            <span class="metric-item__label">{{ 'HOSPITALITY_AI.METRICS.TOTAL_VOTES' | translate }}</span>
            <span class="metric-item__value">{{ formatVotes(metricsData.totals.votes) }}</span>
          </div>
          <div class="metric-item">
            <span class="metric-item__label">{{ 'HOSPITALITY_AI.METRICS.TOTAL_TURNS' | translate }}</span>
            <span class="metric-item__value">{{ formatVotes(metricsData.totals.turns) }}</span>
          </div>
          <div class="metric-item">
            <span class="metric-item__label">{{ 'HOSPITALITY_AI.METRICS.DOWNVOTES_LAST_7_DAYS' | translate }}</span>
            <span class="metric-item__value">{{ formatVotes(metricsData.totals.downvotesLastSevenDays) }}</span>
          </div>
          <div class="metric-item">
            <span class="metric-item__label">{{ 'HOSPITALITY_AI.METRICS.QA_ACTIVE' | translate }}</span>
            <span class="metric-item__value">{{ formatVotes(metricsData.totals.qaEntries.active) }}</span>
          </div>
          <div class="metric-item">
            <span class="metric-item__label">{{ 'HOSPITALITY_AI.METRICS.QA_TOTAL' | translate }}</span>
            <span class="metric-item__value">{{ formatVotes(metricsData.totals.qaEntries.total) }}</span>
          </div>
        </div>

        <nz-divider></nz-divider>

        <div class="recent-section">
          <div class="recent-section__row">
            <div class="recent-section__header">
              <h3>{{ 'HOSPITALITY_AI.RECENT.DOWNVOTES_TITLE' | translate }}</h3>
              <span class="recent-section__count">
                {{ 'HOSPITALITY_AI.RECENT.TOTAL_COUNT' | translate:{ count: metricsData.recent.downvotes.total } }}
              </span>
            </div>
            <nz-table
              nzSize="small"
              [nzData]="metricsData.recent.downvotes.items"
              [nzTotal]="metricsData.recent.downvotes.total"
              [nzPageIndex]="downvotesQuery.page"
              [nzPageSize]="downvotesQuery.pageSize"
              [nzFrontPagination]="false"
              [nzShowPagination]="true"
              [nzPageSizeOptions]="[5, 10, 20, 50]"
              [nzShowSizeChanger]="true"
              [nzNoResult]="'HOSPITALITY_AI.RECENT.NO_DOWNVOTES' | translate"
              (nzQueryParams)="onDownvotesQueryParamsChange($event)"
            >
              <thead>
                <tr>
                  <th
                    nzColumnKey="createdAt"
                    nzShowSort
                    [nzSortFn]="true"
                    [nzSortOrder]="getSortOrder('createdAt', downvotesQuery.sortField, downvotesQuery.sortOrder)"
                  >
                    {{ 'HOSPITALITY_AI.RECENT.DATE' | translate }}
                  </th>
                  <th
                    nzColumnKey="property"
                    nzShowSort
                    [nzSortFn]="true"
                    [nzSortOrder]="getSortOrder('property', downvotesQuery.sortField, downvotesQuery.sortOrder)"
                  >
                    {{ 'HOSPITALITY_AI.RECENT.PROPERTY' | translate }}
                  </th>
                  <th
                    nzColumnKey="language"
                    nzShowSort
                    [nzSortFn]="true"
                    [nzSortOrder]="getSortOrder('language', downvotesQuery.sortField, downvotesQuery.sortOrder)"
                  >
                    {{ 'HOSPITALITY_AI.RECENT.LANGUAGE' | translate }}
                  </th>
                  <th>{{ 'HOSPITALITY_AI.RECENT.REASON' | translate }}</th>
                  <th>{{ 'HOSPITALITY_AI.RECENT.PROMPT' | translate }}</th>
                  <th>{{ 'HOSPITALITY_AI.RECENT.MESSAGE' | translate }}</th>
                  <th class="recent-table__actions-header">{{ 'HOSPITALITY_AI.RECENT.ACTIONS' | translate }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let vote of metricsData.recent.downvotes.items">
                  <td>{{ vote.createdAt | date:'medium' }}</td>
                  <td>
                    <span *ngIf="vote.property; else noProperty">{{ vote.property.address }}</span>
                    <ng-template #noProperty>—</ng-template>
                  </td>
                  <td>{{ ('LANGUAGE_NAMES.' + ((vote.language || 'en') | uppercase)) | translate }}</td>
                  <td>
                    <span *ngIf="vote.reason; else noReason">{{ vote.reason }}</span>
                    <ng-template #noReason>—</ng-template>
                  </td>
                  <td>
                    <ng-container *ngIf="vote.prompt; else noQuestion">
                      <span class="message-cell" nz-tooltip [nzTooltipTitle]="vote.prompt">
                        {{ vote.prompt }}
                      </span>
                    </ng-container>
                    <ng-template #noQuestion>—</ng-template>
                  </td>
                  <td>
                    <ng-container *ngIf="vote.response; else noMessage">
                      <span class="message-cell" nz-tooltip [nzTooltipTitle]="vote.response">
                        {{ vote.response }}
                      </span>
                    </ng-container>
                    <ng-template #noMessage>—</ng-template>
                  </td>
                  <td class="recent-table__actions">
                    <button nz-button nzType="link" nzSize="small" (click)="prefillEntryFromDownvote(vote)">
                      <span nz-icon nzType="plus"></span>
                      {{ 'HOSPITALITY_AI.RECENT.ADD_TO_QA' | translate }}
                    </button>
                  </td>
                </tr>
              </tbody>
            </nz-table>
          </div>

          <div class="recent-section__row">
            <div class="recent-section__header">
              <h3>{{ 'HOSPITALITY_AI.RECENT.TURNS_TITLE' | translate }}</h3>
              <span class="recent-section__count">
                {{ 'HOSPITALITY_AI.RECENT.TOTAL_COUNT' | translate:{ count: metricsData.recent.turns.total } }}
              </span>
            </div>
            <nz-table
              nzSize="small"
              [nzData]="metricsData.recent.turns.items"
              [nzTotal]="metricsData.recent.turns.total"
              [nzPageIndex]="turnsQuery.page"
              [nzPageSize]="turnsQuery.pageSize"
              [nzFrontPagination]="false"
              [nzShowPagination]="true"
              [nzPageSizeOptions]="[5, 10, 20, 50]"
              [nzShowSizeChanger]="true"
              [nzNoResult]="'HOSPITALITY_AI.RECENT.NO_TURNS' | translate"
              (nzQueryParams)="onTurnsQueryParamsChange($event)"
            >
              <thead>
                <tr>
                  <th
                    nzColumnKey="createdAt"
                    nzShowSort
                    [nzSortFn]="true"
                    [nzSortOrder]="getSortOrder('createdAt', turnsQuery.sortField, turnsQuery.sortOrder)"
                  >
                    {{ 'HOSPITALITY_AI.RECENT.DATE' | translate }}
                  </th>
                  <th
                    nzColumnKey="property"
                    nzShowSort
                    [nzSortFn]="true"
                    [nzSortOrder]="getSortOrder('property', turnsQuery.sortField, turnsQuery.sortOrder)"
                  >
                    {{ 'HOSPITALITY_AI.RECENT.PROPERTY' | translate }}
                  </th>
                  <th
                    nzColumnKey="language"
                    nzShowSort
                    [nzSortFn]="true"
                    [nzSortOrder]="getSortOrder('language', turnsQuery.sortField, turnsQuery.sortOrder)"
                  >
                    {{ 'HOSPITALITY_AI.RECENT.LANGUAGE' | translate }}
                  </th>
                  <th>{{ 'HOSPITALITY_AI.RECENT.PROMPT' | translate }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let turn of metricsData.recent.turns.items">
                  <td>{{ turn.createdAt | date:'medium' }}</td>
                  <td>
                    <span *ngIf="turn.property; else noTurnProperty">{{ turn.property.address }}</span>
                    <ng-template #noTurnProperty>—</ng-template>
                  </td>
                  <td>{{ ('LANGUAGE_NAMES.' + ((turn.language || 'en') | uppercase)) | translate }}</td>
                  <td>
                    <span class="message-cell" nz-tooltip [nzTooltipTitle]="turn.prompt">{{ turn.prompt }}</span>
                  </td>
                </tr>
              </tbody>
            </nz-table>
          </div>
        </div>
      </ng-container>
    </nz-card>

    <nz-card class="qa-management-card" [nzTitle]="'HOSPITALITY_AI.QA_SECTION.TITLE' | translate" #qaFormSection>
      <nz-alert
        *ngIf="prefillAlertVisible"
        class="qa-prefill-alert"
        nzType="info"
        nzShowIcon
        [nzMessage]="'HOSPITALITY_AI.RECENT.PREFILL_ALERT_TITLE' | translate"
        [nzDescription]="prefillAlertMessage"
      ></nz-alert>
      <form nz-form class="qa-form" [formGroup]="entryForm" (ngSubmit)="submitEntry()">
        <div class="qa-form__grid">
          <nz-form-item>
            <nz-form-label nzRequired>{{ 'HOSPITALITY_AI.QA_SECTION.COMPANY' | translate }}</nz-form-label>
            <nz-form-control nzErrorTip="{{ 'HOSPITALITY_AI.QA_SECTION.COMPANY_ERROR' | translate }}">
              <nz-select
                formControlName="companyId"
                nzShowSearch
                [nzDisabled]="!canFilterCompanies"
                nzPlaceHolder="{{ 'HOSPITALITY_AI.QA_SECTION.COMPANY_PLACEHOLDER' | translate }}"
              >
                <nz-option *ngFor="let company of companyOptions" [nzValue]="company.id" [nzLabel]="company.name"></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>

          <nz-form-item>
            <nz-form-label>{{ 'HOSPITALITY_AI.QA_SECTION.PROPERTY' | translate }}</nz-form-label>
            <nz-form-control>
              <nz-select formControlName="propertyId" nzAllowClear nzShowSearch nzPlaceHolder="{{ 'HOSPITALITY_AI.QA_SECTION.PROPERTY_PLACEHOLDER' | translate }}">
                <nz-option *ngFor="let property of propertyOptionsForEntry" [nzValue]="property.id" [nzLabel]="property.address"></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>

          <nz-form-item>
            <nz-form-label>{{ 'HOSPITALITY_AI.QA_SECTION.LANGUAGE' | translate }}</nz-form-label>
            <nz-form-control>
              <nz-select formControlName="language" nzAllowClear nzPlaceHolder="{{ 'HOSPITALITY_AI.QA_SECTION.LANGUAGE_PLACEHOLDER' | translate }}">
                <nz-option *ngFor="let language of languageOptions" [nzValue]="language.code" [nzLabel]="('LANGUAGE_NAMES.' + (language.code | uppercase)) | translate"></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>

          <nz-form-item class="qa-form__switch">
            <nz-form-label>{{ 'HOSPITALITY_AI.QA_SECTION.IS_ACTIVE' | translate }}</nz-form-label>
            <nz-form-control>
              <nz-switch formControlName="isActive"></nz-switch>
            </nz-form-control>
          </nz-form-item>
        </div>

        <nz-form-item>
          <nz-form-label nzRequired>{{ 'HOSPITALITY_AI.QA_SECTION.QUESTION' | translate }}</nz-form-label>
          <nz-form-control nzErrorTip="{{ 'HOSPITALITY_AI.QA_SECTION.QUESTION_ERROR' | translate }}">
            <textarea nz-input formControlName="question" rows="3"></textarea>
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label nzRequired>{{ 'HOSPITALITY_AI.QA_SECTION.ANSWER' | translate }}</nz-form-label>
          <nz-form-control nzErrorTip="{{ 'HOSPITALITY_AI.QA_SECTION.ANSWER_ERROR' | translate }}">
            <textarea nz-input formControlName="answer" rows="4"></textarea>
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label>{{ 'HOSPITALITY_AI.QA_SECTION.TAGS' | translate }}</nz-form-label>
          <nz-form-control>
            <input nz-input formControlName="tags" placeholder="{{ 'HOSPITALITY_AI.QA_SECTION.TAGS_PLACEHOLDER' | translate }}" />
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label>{{ 'HOSPITALITY_AI.QA_SECTION.SOURCE' | translate }}</nz-form-label>
          <nz-form-control>
            <input nz-input formControlName="source" placeholder="{{ 'HOSPITALITY_AI.QA_SECTION.SOURCE_PLACEHOLDER' | translate }}" />
          </nz-form-control>
        </nz-form-item>

        <div class="qa-form__actions">
          <button nz-button nzType="primary" [nzLoading]="savingEntry">
            {{ isEditing ? ('HOSPITALITY_AI.QA_SECTION.UPDATE' | translate) : ('HOSPITALITY_AI.QA_SECTION.SAVE' | translate) }}
          </button>
          <button nz-button type="button" nzType="default" (click)="cancelEdit()">
            {{ 'HOSPITALITY_AI.QA_SECTION.CANCEL' | translate }}
          </button>
          <button nz-button type="button" nzType="link" (click)="startCreate()" *ngIf="isEditing">
            {{ 'HOSPITALITY_AI.QA_SECTION.CREATE_NEW' | translate }}
          </button>
        </div>
      </form>

      <div class="qa-table-header">
        <div class="qa-table-header__title">
          <span nz-icon nzType="database"></span>
          <span>{{ 'HOSPITALITY_AI.QA_SECTION.LIST_TITLE' | translate }}</span>
        </div>
        <div class="qa-table-header__search">
          <input
            nz-input
            [(ngModel)]="searchTerm"
            name="qaSearch"
            [placeholder]="'HOSPITALITY_AI.QA_SECTION.SEARCH_PLACEHOLDER' | translate"
            (keyup.enter)="onSearch()"
          />
          <button nz-button nzType="default" (click)="onSearch()">
            {{ 'HOSPITALITY_AI.QA_SECTION.SEARCH' | translate }}
          </button>
        </div>
      </div>

      <nz-table
        class="qa-table"
        [nzData]="entries"
        [nzLoading]="loadingEntries"
        [nzFrontPagination]="false"
        [nzPageIndex]="pagination.page"
        [nzPageSize]="pagination.pageSize"
        [nzTotal]="pagination.total"
        [nzShowPagination]="true"
        [nzShowSizeChanger]="true"
        [nzPageSizeOptions]="[5, 10, 20, 50]"
        [nzScroll]="{ x: '1200px' }"
        (nzQueryParams)="onEntriesQueryParamsChange($event)"
      >
        <thead>
          <tr>
            <th
              nzColumnKey="question"
              nzShowSort
              [nzSortFn]="true"
              [nzSortOrder]="getSortOrder('question', qaSort.sortField, qaSort.sortOrder)"
            >
              {{ 'HOSPITALITY_AI.QA_SECTION.TABLE.QUESTION' | translate }}
            </th>
            <th>{{ 'HOSPITALITY_AI.QA_SECTION.TABLE.ANSWER' | translate }}</th>
            <th *ngIf="canFilterCompanies">{{ 'HOSPITALITY_AI.QA_SECTION.TABLE.COMPANY' | translate }}</th>
            <th
              nzColumnKey="property"
              nzShowSort
              [nzSortFn]="true"
              [nzSortOrder]="getSortOrder('property', qaSort.sortField, qaSort.sortOrder)"
            >
              {{ 'HOSPITALITY_AI.QA_SECTION.TABLE.PROPERTY' | translate }}
            </th>
            <th
              nzColumnKey="language"
              nzShowSort
              [nzSortFn]="true"
              [nzSortOrder]="getSortOrder('language', qaSort.sortField, qaSort.sortOrder)"
            >
              {{ 'HOSPITALITY_AI.QA_SECTION.TABLE.LANGUAGE' | translate }}
            </th>
            <th>{{ 'HOSPITALITY_AI.QA_SECTION.TABLE.TAGS' | translate }}</th>
            <th
              nzColumnKey="isActive"
              nzShowSort
              [nzSortFn]="true"
              [nzSortOrder]="getSortOrder('isActive', qaSort.sortField, qaSort.sortOrder)"
            >
              {{ 'HOSPITALITY_AI.QA_SECTION.TABLE.STATUS' | translate }}
            </th>
            <th
              nzColumnKey="updatedAt"
              nzShowSort
              [nzSortFn]="true"
              [nzSortOrder]="getSortOrder('updatedAt', qaSort.sortField, qaSort.sortOrder)"
            >
              {{ 'HOSPITALITY_AI.QA_SECTION.TABLE.UPDATED' | translate }}
            </th>
            <th>{{ 'HOSPITALITY_AI.QA_SECTION.TABLE.ACTIONS' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let entry of entries; trackBy: trackEntry">
            <td>
              <span nz-tooltip [nzTooltipTitle]="entry.question">{{ entry.question }}</span>
            </td>
            <td>
              <span nz-tooltip [nzTooltipTitle]="entry.answer">{{ entry.answer }}</span>
            </td>
            <td *ngIf="canFilterCompanies">{{ entry.company?.name || '—' }}</td>
            <td>{{ entry.property?.address || '—' }}</td>
            <td>{{ ('LANGUAGE_NAMES.' + ((entry.language || 'en') | uppercase)) | translate }}</td>
            <td>
              <nz-tag *ngFor="let tag of entry.tags">{{ tag }}</nz-tag>
              <span *ngIf="!entry.tags?.length">—</span>
            </td>
            <td>
              <nz-tag [nzColor]="entry.isActive ? 'green' : 'red'">
                {{ entry.isActive ? ('HOSPITALITY_AI.QA_SECTION.STATUS_ACTIVE' | translate) : ('HOSPITALITY_AI.QA_SECTION.STATUS_INACTIVE' | translate) }}
              </nz-tag>
            </td>
            <td>{{ entry.updatedAt | date:'short' }}</td>
            <td class="qa-table__actions">
              <button nz-button nzType="link" (click)="startEdit(entry)">
                {{ 'HOSPITALITY_AI.QA_SECTION.EDIT' | translate }}
              </button>
              <button
                nz-button
                nzType="link"
                nzDanger
                nz-popconfirm
                [nzPopconfirmTitle]="'HOSPITALITY_AI.QA_SECTION.DELETE_CONFIRM' | translate"
                (nzOnConfirm)="deleteEntry(entry)"
              >
                {{ 'HOSPITALITY_AI.QA_SECTION.DELETE' | translate }}
              </button>
            </td>
          </tr>
        </tbody>
      </nz-table>
    </nz-card>
  </nz-spin>
</div>

<ng-template #noMetrics>
  <nz-alert nzType="info" [nzMessage]="'HOSPITALITY_AI.METRICS.NO_DATA' | translate"></nz-alert>
</ng-template>
